import { asKeyedRoutes } from '../utils/asKeyedRoutes';

export const makeKeysRoutes = asKeyedRoutes({});
